import { defineMessages } from 'react-intl';

export const organisationMessages = defineMessages({
    editOrganisation: {
        id: 'edit-organisation',
        defaultMessage: 'Edit organisation',
    },
    addOrganisationSubtitle: {
        id: 'add-organisation-subtitle',
        defaultMessage: 'Add new organisation',
    },
    editOrganisationSubtitle: {
        id: 'edit-organisation-subtitle',
        defaultMessage: 'Edit organisation {entry}',
    },
    deleteOrganisationSubtitle: {
        id: 'delete-organisation-subtitle',
        defaultMessage: 'Permanently delete organisation {entry}',
    },
    confirmDeleteOrganisation: {
        id: 'confirm-delete-organisation',
        defaultMessage: 'Are you sure you want to delete organisation {entry}? This action cannot be undone.',
    },
    organisations: {
        id: 'organisations',
        defaultMessage: 'Organisations',
    },
    organisation: {
        id: 'organisation',
        defaultMessage: 'Organisation',
    },
    name: {
        id: 'name',
        defaultMessage: 'Name',
    },
    uic: {
        id: 'uic',
        defaultMessage: 'UIC',
    },
    taxNumber: {
        id: 'tax-number',
        defaultMessage: 'Tax number',
    },
    address: {
        id: 'address',
        defaultMessage: 'Address',
    },
    legalRepresentative: {
        id: 'legal-representative',
        defaultMessage: 'Legal representative',
    },
    createOrganisationSuccess: {
        id: 'create-organisation-success',
        defaultMessage: 'Organisation created',
    },
    updateOrganisationSuccess: {
        id: 'update-organisation-success',
        defaultMessage: 'Organisation updated',
    },
    deleteOrganisationSuccess: {
        id: 'delete-organisation-success',
        defaultMessage: 'Organisation deleted',
    },
    createOrganisationSuccessDescription: {
        id: 'create-organisation-success-description',
        defaultMessage: 'Organisation {entry} has been successfully created.',
    },
    updateOrganisationSuccessDescription: {
        id: 'update-organisation-success-description',
        defaultMessage: 'Organisation {entry} has been successfully updated.',
    },
    deleteOrganisationSuccessDescription: {
        id: 'delete-organisation-success-description',
        defaultMessage: 'Organisation {entry} has been successfully deleted.',
    },
});
